<template>
    <div>
        <base-alert type="danger" v-if="quotaLevel == 2">
            <i class="fas fa-database mr-2"></i> {{ $t('pwa.quota-danger') }}
        </base-alert>

        <base-alert type="warning" v-if="quotaLevel == 1">
            <i class="fas fa-database mr-2"></i> {{ $t('pwa.quota-warning') }}
        </base-alert>

        <div class="text-muted text-center mt-3 mb-3" v-if="about">
            <small>{{ message }}</small>
        </div>

        <div class="text-muted text-center mt-3 mb-3" v-if="about && !trash">

            <base-button type="secondary" size="" @click="goHome">
                <span class="btn-inner--icon mr-1"><i class="fas fa-home"></i></span>
                <span class="btn-inner--text">{{ $t('common.home') }}</span>
            </base-button>

            <base-button type="secondary" size="" @click="openTrash">
                <span class="btn-inner--icon mr-1"><i class="fas fa-trash-alt"></i></span>
                <span class="btn-inner--text">{{ $t('pwa.trash') }}</span>
            </base-button>

            <base-button type="secondary" size="" @click="checkup">
                <span class="btn-inner--icon mr-1"><i class="fas fa-wrench"></i></span>
                <span class="btn-inner--text">{{ $t('pwa.checkup') }}</span>
            </base-button>
        </div>

        <div class="text-muted text-center mt-3 mb-3" v-if="trash">

            <base-button type="secondary" size="" @click="goHome">
                <span class="btn-inner--icon mr-1"><i class="fas fa-home"></i></span>
                <span class="btn-inner--text">{{ $t('common.home') }}</span>
            </base-button>

            <base-button type="secondary" size="" @click="openOfflineDashboard">
                <span class="btn-inner--icon mr-1"><i class="tim-icons icon-plug-2"></i></span>
                <span class="btn-inner--text">{{ $t('pwa.dashboard') }}</span>
            </base-button>

            <base-button type="secondary" size="" @click="emptyTrash">
                <span class="btn-inner--icon mr-1 text-danger"><i class="fas fa-times-circle"></i></span>
                <span class="btn-inner--text">{{ $t('pwa.empty-trash') }}</span>
            </base-button>

            <!--
            <base-button type="secondary" size="" @click="cleanup">
                <span class="btn-inner--icon mr-1"><i class="fas fa-broom"></i></span>
                <span class="btn-inner--text">{{ $t('pwa.cleanup') }}</span>
            </base-button>
            -->
        </div>

        <portal to="modals">

            <confirm-modal v-model="modals.emptyTrash">
                <p>{{ $t('pwa.empty-trash-confirm') }}</p>
            </confirm-modal>

        </portal>
    </div>
</template>

<script>
    import ModalsController from '@trax/classes/ModalsController'

    export default {

        props: {

            trash: {
                type: Boolean,
                default: false
            },
        },

        data() {
            return {
                about: null,
                modals: new ModalsController(['emptyTrash']),
            }
        },

        created() {
            this.modals.init(this, 'modals')
            this.getAbout()
        },

        computed: {

            message() {
                if (this.about.unavailable || this.about.app_version === undefined) {
                    return this.$t('pwa.unavailable')
                }
                return this.$t('pwa.available')
                    + ' App version: ' + this.about.app_version
                    + '. Cache version: ' + this.about.cache_version
                    + '. DB version: ' + this.about.db_version
                    + '. Used space: ' + this.quotaUsagePercent + '%'
                    + '. Free space: ' + this.quotaUsageFree + 'Mo'
            },

            quotaUsagePercent() {
                if (!this.about || !this.about.quota) {
                    return 'unknown'
                }
                return parseInt(this.about.quota.usage * 100 / this.about.quota.quota)
            },

            quotaUsageFree() {
                if (!this.about || !this.about.quota) {
                    return 'unknown'
                }
                return parseInt((this.about.quota.quota - this.about.quota.usage) / (1024 * 1024))
            },

            quotaLevel() {
                if (!this.about || !this.about.quota) {
                    return 0
                }
                const usage = this.quotaUsagePercent
                if (usage >= 80) {
                    return 2
                }
                if (usage >= 50) {
                    return 1
                }
                return 0
            }
        },

        methods: {

            getAbout() {
                axios.get('/socrates/api/front/pwa/about').then(resp => {
                    this.about = resp.data
                }).catch(error => {
                    this.about = { unavailable: true }
                })
            },

            goHome() {
                this.$router.push({name: 'home'})
            },

            openTrash() {
                this.$router.push({name: 'offline-trash'})
            },

            openOfflineDashboard() {
                this.$router.push({name: 'offline-dashboard'})
            },

            cleanup() {
                axios.post('/socrates/api/front/offline/cleanup')
                .then(resp => {
                    this.$notify({type: 'primary', message: this.$t('pwa.cleanup-done') })
                    this.getAbout()
                })
            },

            checkup() {
                axios.post('/socrates/api/front/offline/checkup')
                .then(resp => {
                    this.$notify({type: 'primary', message: this.$t('pwa.checkup-done') })
                    this.getAbout()
                })
            },

            emptyTrash() {
                this.modals.open('emptyTrash').then(confirmResponse => {
                    if (confirmResponse.confirmed) {
                        axios.delete('/socrates/api/front/offline/trash')
                        .then(resp => {
                            this.getAbout()
                            this.$emit('trash-empty')
                        })
                    }
                })
            }
        }
    }
</script>
